export default __webpack_public_path__ + "static/media/supoj-signature.97c6f886.png";